<div class="card voffset-5">
    <div class="card-body" [ngClass]="{'border-red background-panel': item().isRemoved || item().removedOptions.length > 0}">
        <div class="row">
            <div class="col">
                <h6 class="card-title main-blue">{{ item().campName }} - {{ item().sessionName }}</h6>

            </div>
            @if (item().isRemoved) {
                <div class="col-md-auto">
                    <p class="lead main-red">{{ 'PurchaseEdit.removed' | translate }}</p>
                </div>
            }
        </div>
        <div class="card-text voffset-10">

            <div class="row">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.location' | translate }}</div>
                        <div class="col-sm-9">{{ item().clubInfo.name }} ({{ item().clubInfo.code }})</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.child' | translate }}</div>
                        <div class="col-sm-9">{{ item().childFullName }}</div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.details' | translate }}</div>
                        <div class="col-sm-9"> {{ timeVariant() }} ({{ item().timeVariant.fromInMinutes | timeDisplay }}
                            - {{ item().timeVariant.toInMinutes | timeDisplay }})
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.campDays' | translate }}</div>
                        <div class="col-sm-9">
                            @for (campDay of item().campDays; track $index) {
                                <span>
                                    {{ campDay | bcDate }}
                                    @if (!$last) {
                                        <span>, </span>
                                    }
                                </span>
                            }
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.selectedOptions' | translate }}</div>
                        @if (item().options.length > 0) {
                            <div class="col-sm-9">
                                @for (option of item().options; track $index) {
                                    <span>
                                        {{ option }}
                                        @if (!$last) {
                                            <span>, </span>
                                        }
                                    </span>
                                }
                            </div>
                        } @else if (item().options.length == 0) {
                            <div class="col-sm-9">{{ 'PurchaseEdit.noneOptions' | translate }}</div>
                        }

                    </div>
                </div>
                <div class="col-sm-6 ">

                    <div class="row justify-content-end">
                        <div class="col-sm-9 bolded text-align-right">{{ 'PurchaseEdit.basePrice' | translate }}</div>
                        <div class="col-sm-3 bolded main-green">
                            <span class="right">{{ item().cost.basePrice | amount }}</span>
                        </div>
                    </div>
                    @for (discount of item().cost.discounts; track $index) {
                        <div class="row">
                            <div class="col-sm-9 bolded text-align-right">
                                <span>{{ discount.name }}:</span>
                            </div>
                            <div class="col-sm-3 bolded main-green">
                                <span class="main-red right">-{{ discount.value| amount }}</span>
                            </div>
                        </div>
                    }
                    @for (discount of item().cost.removedDiscounts; track $index) {
                        <div class="row">
                            <div class="col-sm-9 bolded text-align-right">
                                <span>{{ discount.name }}:</span>
                            </div>
                            <div class="col-sm-3 bolded main-green">
                                <span class="main-red right old-price">-{{ discount.value| amount }}</span>
                            </div>
                        </div>
                    }
                    <div class="row justify-content-end">
                        <div class="col-sm-9 bolded text-align-right">{{ 'PurchaseEdit.tuitionFinal' | translate }}
                        </div>
                        <div class="col-sm-3 bolded main-green">
                            <span class="right">{{ item().cost.tuitionAmount | amount }}</span>
                            @if (item().cost.originalTuitionAmount) {
                                <span class="old-price mr-1 right">
                                    {{ item().cost.originalTuitionAmount | amount }}
                                </span>
                            }
                        </div>
                    </div>

                    @if (!item().isRemoved && (item().cost.deduction.numberOfWeeks > 0 || item().cost.originalDeduction.numberOfWeeks > 0)) {
                        <div class="row justify-content-end">
                            <div class="col-sm-9 bolded text-align-right">Weeks deducted:</div>
                            <div class="col-sm-3 bolded main-green">
                                @if (item().cost.deduction.numberOfWeeks) {
                                    <span class="right">
                                        <span class="old-price">
                                            {{ item().cost.originalDeduction.numberOfWeeks }}/
                                            <span class="ml-1">{{ item().cost.originalDeduction.numberOfDays }}</span>
                                        </span>
                                        <span class="ml-1">
                                            {{ item().cost.deduction.numberOfWeeks }}
                                            /{{ item().cost.deduction.numberOfDays }}
                                        </span>
                                    </span>
                                }
                            </div>
                        </div>
                    }

                    @if (!item().isRemoved && (item().cost.deduction.value > 0 || item().cost.originalDeduction.value > 0)) {
                        <div class="row justify-content-end">
                            <div class="col-sm-9 bolded text-align-right">Value of days deducted:</div>
                            <div class="col-sm-3 bolded main-green">
                                @if (item().cost.originalDeduction.hasDeduction) {
                                    <span class="right">
                                        <span class="old-price">
                                            {{ item().cost.originalDeduction.value | amount }}
                                        </span>
                                        <span class="ml-1">{{ item().cost.deduction.value  | amount }}</span>
                                    </span>
                                }
                            </div>
                        </div>
                    }

                    @if (item().cost.optionsAmount > 0) {
                        <div class="row justify-content-end">
                            <div
                                class="col-sm-9 bolded text-align-right">{{ 'PurchaseEdit.additionalOptions' | translate }}
                            </div>
                            <div class="col-sm-3 bolded main-green">
                                <span class="right">{{ item().cost.optionsAmount | amount }}</span>
                            </div>
                        </div>
                    }

                    @if (options().length > 0) {
                        <div class="d-flex justify-content-end">
                            <div class="grid mt-2">
                                <div class="separator"></div>
                                @for (option of options(); track option.id) {
                                    <div>
                                        @if (option.isRemoved) {
                                            <span class="main-red" translate="PurchaseEdit.optionRemoved"></span>
                                        }
                                    </div>
                                    <div>
                                        <span [ngClass]="{ 'old-price': option.isRemoved }">{{ option.name }}</span>
                                    </div>
                                    <div>
                                    <span [ngClass]="option.isRemoved ? 'old-price' : 'main-green'">
                                        {{ option.pricePerSession | amount }}
                                    </span>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                </div>
            </div>

        </div>
    </div>
